// Configurazione social. Imposta BEHOLD_FEED_ID con l'ID feed generato su behold.so
// per attivare il feed Instagram live. Finché è vuoto, viene mostrato un fallback
// con il link al profilo.
export const INSTAGRAM_HANDLE = "torri.solar";
export const INSTAGRAM_URL = "https://www.instagram.com/torri.solar/";
export const BEHOLD_FEED_ID = "8vyICyzqhW1UBpuVLV4y";
